/**
 * CourseSessionStatusService
 * Service for CourseSessionStatus entity operations
 * Route: api/course-session-statuses
 */
import { BaseService } from '../base/BaseService';
/**
 * CourseSessionStatusService
 * Handles course session status CRUD operations
 */
export class CourseSessionStatusService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CourseSessionStatusService.DEFAULT_SERVICE_PATH,
            basePath: CourseSessionStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all course session statuses
     * @returns Promise resolving to array of course session statuses
     */
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    /**
     * Get all course session statuses (raw response)
     * @returns Promise resolving to ResponseData with course session statuses
     */
    getAllRaw() {
        const url = this.buildUrl('');
        return this.http.get(url);
    }
    /**
     * Get course session status by ID
     * @param id - Status ID
     * @returns Promise resolving to course session status or null
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        return response.data ?? null;
    }
    /**
     * Get course session status by ID (raw response)
     * @param id - Status ID
     * @returns Promise resolving to ResponseData with course session status
     */
    getByIdRaw(id) {
        const endpoint = this.getEndpoint('getById', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    /**
     * Create a new course session status
     * @param status - Status data
     * @returns Promise resolving to created course session status
     */
    async create(status) {
        const response = await this.createRaw(status);
        return response.data ?? null;
    }
    /**
     * Create a new course session status (raw response)
     * @param status - Status data
     * @returns Promise resolving to ResponseData with created course session status
     */
    createRaw(status) {
        const url = this.buildUrl('');
        return this.http.post(url, status);
    }
    /**
     * Update an existing course session status
     * @param id - Status ID
     * @param status - Updated status data
     * @returns Promise resolving to updated course session status
     */
    async update(id, status) {
        const response = await this.updateRaw(id, status);
        return response.data ?? null;
    }
    /**
     * Update an existing course session status (raw response)
     * @param id - Status ID
     * @param status - Updated status data
     * @returns Promise resolving to ResponseData with updated course session status
     */
    updateRaw(id, status) {
        const endpoint = this.getEndpoint('update', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.put(url, status);
    }
    /**
     * Delete a course session status
     * @param id - Status ID
     * @returns Promise resolving to true if successful
     */
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    /**
     * Delete a course session status (raw response)
     * @param id - Status ID
     * @returns Promise resolving to ResponseData
     */
    deleteRaw(id) {
        const endpoint = this.getEndpoint('delete', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
CourseSessionStatusService.DEFAULT_SERVICE_PATH = 'resources';
CourseSessionStatusService.BASE_PATH = 'api/course-session-statuses';
//# sourceMappingURL=CourseSessionStatusService.js.map